var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-video',{attrs:{"full-width":true,"text":_vm.text,"variant":_vm.variant,"video":_vm.video,"video-left":_vm.videoLeft}})}
var staticRenderFns = []

export { render, staticRenderFns }